export enum SiteType {
    FACILITY = 1,
    LOCATION = 2,
    AREA = 3,
  }